import { createContext, PropsWithChildren, useReducer } from "react";

import { create } from "@bufbuild/protobuf";

import { SourceBrowserbaseConfigurationSchema } from "@gx/ts-contracts/services/source/resources/source_configuration/browserbase/browserbase_pb";

import { CreateSourceBrowserbaseAction } from "@/pages/sources/components/create/sources/browserbase/actions";
import { DEFAULT_MAX_URLS_TO_SCRAPE } from "@/pages/sources/components/create/sources/browserbase/constants";
import createSourceBrowserbaseReducer from "@/pages/sources/components/create/sources/browserbase/reducer";
import {
  CreateSourceBrowserbasePhase,
  CreateSourceBrowserbaseState,
} from "@/pages/sources/components/create/sources/browserbase/types";

export interface CreateSourceBrowserbaseContextShape {
  state: CreateSourceBrowserbaseState;
  dispatch: React.Dispatch<CreateSourceBrowserbaseAction>;
}

export const DEFAULT_STATE: CreateSourceBrowserbaseState = {
  sourceName: "",
  phase: CreateSourceBrowserbasePhase.IDLE,
  error: null,
  shouldShowErrors: false,
  configuration: create(SourceBrowserbaseConfigurationSchema, {
    rootUrl: "",
    prompt: undefined,
    isGalaxyManagedCredentials: true,
    apiKey: undefined,
    scrapeLimit: DEFAULT_MAX_URLS_TO_SCRAPE,
  }),
};

export const CreateSourceBrowserbaseContext =
  createContext<CreateSourceBrowserbaseContextShape | null>(null);
CreateSourceBrowserbaseContext.displayName = "CreateSourceBrowserbaseContext";

const CreateSourceBrowserbaseProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(createSourceBrowserbaseReducer, DEFAULT_STATE);

  return (
    <CreateSourceBrowserbaseContext.Provider value={{ state, dispatch }}>
      {children}
    </CreateSourceBrowserbaseContext.Provider>
  );
};

export default CreateSourceBrowserbaseProvider;
